module.exports = __webpack_public_path__ + "img/loading.17459332.png";